import {TOGGLE_MENU} from '../constants/iteractions';

export const toggleMenu = () => {
	return {
		type: TOGGLE_MENU,
		payload: {}
	};
};